export default __webpack_public_path__ + "static/media/smart-chain-square.1d24deb2.png";